import { render, staticRenderFns } from "./input-textarea.vue?vue&type=template&id=4626ac9f&scoped=true"
import script from "./input-textarea.ts?vue&type=script&lang=ts&external"
export * from "./input-textarea.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4626ac9f",
  null
  
)

export default component.exports